interface IProp {
  className?: string
}

const SmoothFlooring = (props: IProp) => {
  const { className = 'fill-black' } = props
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path d="M13 10H10V9H13V10ZM15 14H12V13H15V14ZM14 12H11V11H14V12Z" className={className} />
      <path
        d="M8.50169 10C8.49793 9.57816 8.3853 9.16443 8.17471 8.79889C7.96413 8.43335 7.66273 8.12837 7.29969 7.9135L11.0002 1.5L10.1352 1L6.34669 7.563C5.88174 7.45918 5.39818 7.47357 4.94022 7.60485C4.48227 7.73613 4.06452 7.98012 3.72519 8.3145C1.85319 10.12 1.99819 14.341 2.00519 14.52C2.01036 14.6491 2.06531 14.7712 2.15853 14.8607C2.25174 14.9502 2.37598 15.0001 2.50519 15H10.0007C10.1056 15 10.2079 14.967 10.293 14.9056C10.3782 14.8443 10.4418 14.7577 10.475 14.6581C10.5082 14.5586 10.5092 14.4511 10.4779 14.3509C10.4467 14.2507 10.3846 14.163 10.3007 14.1C8.53069 12.772 8.50169 10.027 8.50169 10ZM5.96519 8.4985C6.36538 8.5029 6.74846 8.66142 7.03474 8.94108C7.32102 9.22075 7.48845 9.60003 7.50219 10C7.50219 10.019 7.50319 10.104 7.51069 10.2345L4.56069 8.9225C4.75501 8.76226 4.97925 8.64226 5.22037 8.56947C5.46148 8.49668 5.71467 8.47256 5.96519 8.4985ZM7.72519 14C7.32554 13.5931 7.07079 13.066 7.00019 12.5H6.00019C6.036 13.0321 6.20222 13.5473 6.48419 14H5.37269C5.16698 13.3511 5.04188 12.6794 5.00019 12H4.00019C4.03224 12.6774 4.14384 13.3487 4.33269 14H3.00019C3.01569 13.082 3.14519 11.054 3.90169 9.7235L7.66819 11.3985C7.84876 12.3383 8.23461 13.2266 8.79819 14H7.72519Z"
        className={className}
      />
    </svg>
  )
}

export default SmoothFlooring
